import { Component, OnInit, Input } from "@angular/core";
import { BillOperationRP, GetBillOperationsRP, BillOperationDto } from "app/open-api/model/billOperation";
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { BillService } from 'app/open-api';
import { ListBillsByFlightRQ } from 'app/open-api/model/listBillsByFlightRQ';
import { BillModel } from 'app/open-api/model/billModel';
import { BillLocalModel } from 'app/shared/models/bill.model';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-flight-bills',
  templateUrl: './flight-bills.component.html',
  styleUrls: ['./flight-bills.component.scss'],
  providers: [ DatePipe],
})
export class FlightBillsComponent implements OnInit {
  @Input() flightId: number;
  page = 1;
  pageSize = 10;
  collectionSize = 0;
  bills: BillLocalModel[] = [];  
  allBills: BillLocalModel[] = []; 

  constructor(public activeModal: NgbActiveModal, private datePipe: DatePipe, private spinner: NgxSpinnerService, private _billService: BillService) { }

  ngOnInit() {
    this.getBillsByFlight();
  }

  ModelParse(array: BillModel[]): BillLocalModel[] {
    return array.map(({ customerModel, senderModel, ...rest }) => ({
      ...rest,
      customerModel: JSON.parse(customerModel || ''),
      senderModel: JSON.parse(senderModel || ''),
    }));
  }

  get allbills(): BillLocalModel[] {    
    return this.allBills.length > 0 ? this.allBills
      .map((bill, i) => ({ id: i + 1, ...bill }))
      .slice(
        (this.page - 1) * this.pageSize,
        (this.page - 1) * this.pageSize + this.pageSize
      ) : [];   
}

  getBillsByFlight(){
    //this.operations = [];
    //this.allOrders = [];

    this.spinner.show();
    const param: ListBillsByFlightRQ = {
      flightId : this.flightId
    };

    this._billService.apiBillListByFlight(param).subscribe(
      (response) => {
        if(response){

          this.bills = this.ModelParse(response.list);
          this.allBills = this.ModelParse(response.list);
          this.collectionSize = this.allBills.length;
        }       
              
        this.spinner.hide();
      },
      (error) => {
        //this.currentStep = 1;       

        Swal.fire({
          title: "Ha occurrido un error inesperado al obtener las operaciones.",
          icon: "error",
          showConfirmButton: false,
          timer: 5000,
          position: "top",
        });
        this.spinner.hide();
      }
    );
    
  }
  

}
